import {Component, OnInit, ViewChildren} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';
import {ActivatedRoute} from '@angular/router';
import {ProductosService} from '../../../core/services/nuevaLogica/productos/productos.service';

@Component({
  selector: 'app-lista-productos',
  templateUrl: './lista-productos.component.html',
  styleUrls: ['./lista-productos.component.scss'],
  animations: [  // angular animation
    trigger('Animation', [
      transition('* => fadeOut', [
        style({opacity: 0.1}),
        animate(1000, style({opacity: 0.1}))
      ]),
      transition('* => fadeIn', [
        style({opacity: 0.1}),
        animate(1000, style({opacity: 0.1}))
      ])
    ])
  ]
})
export class ListaProductosComponent implements OnInit {
  @ViewChildren('product') productsBox: any;
  searchInput: string;
  p = 1;
  public items: any[] = [];
  allItems: any[] = [];
  public animation: any;
  filtros: any;
  productosCargados = false;

  constructor(
    private route: ActivatedRoute,
    private productosService: ProductosService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.allItems = [];
      this.filtros = params;
      this.productosCargados = false;
      this.getProductos();
    });
  }

  getProductos() {
    this.productosService.get(this.filtros).subscribe({
      next: data => this.allItems = data,
      complete: () => this.productosCargados = true
    });
  }

  filtroBuscar() {
   /* const filter = this.searchInput.toUpperCase();
    this.productsBox._results.forEach((element: ElementRef) => {
      if (element.nativeElement.text.toUpperCase().indexOf(filter) > -1) {
        this.renderer2.setStyle(element.nativeElement, 'display', '');
      } else {

        this.renderer2.setStyle(element.nativeElement, 'display', 'none');
      }
    });*/
  }

}
